import { render } from "./CohortsView.html?vue&type=template&id=1f23a9f6"
import script from "./CohortsView.js?vue&type=script&lang=js"
export * from "./CohortsView.js?vue&type=script&lang=js"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__